import {FC} from 'react'
import {KTSVG} from '../../../../helpers'

type Props = {
  className: string
  chartSize?: number
  chartLine?: number
  chartRotate?: number
}

const CardsWidget17: FC<Props> = ({
  className,
  chartSize = 70,
  chartLine = 11,
  chartRotate = 145,
}) => {
  // Constants
  const totalAdditionalJobs = 50102
  const increasePercentage = 22
  const currentDemand = 10450
  const averageEarnings = 63496

  return (
    <div className={`card card-flush ${className}`}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <div className='d-flex align-items-center'>
            <span className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>
              {totalAdditionalJobs.toLocaleString()}
            </span>
            <span className='badge badge-light-success fs-base'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr066.svg'
                className='svg-icon-5 svg-icon-success ms-n1'
              />{' '}
              {increasePercentage}%
            </span>
          </div>
          <span className='text-gray-400 pt-1 fw-semibold fs-6'>
            Estimated Additional Jobs (years) Needed for IIJA and IRA Demand
          </span>
        </div>
      </div>

      <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
        <div className='d-flex flex-column content-justify-center flex-row-fluid'>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-success me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>
              Current Existing Demand for IIJA / IRA Occupations
            </div>
            <div className='fw-bolder text-gray-700 text-xxl-end'>
              {currentDemand.toLocaleString()}
            </div>
          </div>
          <div className='d-flex fw-semibold align-items-center my-3'>
            <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>Avg. Earnings Per Job</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'>
              $ {averageEarnings.toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {CardsWidget17}
